import React from "react";

const Footer = () => {
  return (
    <div className="bg-gray-800 text-sm p-4 text-center text-white mt-8">
      Copyright © 2022 Nahid Parvez.All Rights reserved.
    </div>
  );
};

export default Footer;
